import { withDialogSuspenseErrorBoundary } from '@retail/components';
import { useCallback, useState } from 'react';
import { useAppTFunction } from '@retail/app/i18n';
import { ItemAgreementPrices } from '@retail/purchase-agreements/types';
import { useConditionActions } from '@retail/calculus/context';
import { toConditionBinding } from '@retail/calculus/types';
import { SelectItemAgreements } from '@retail/purchase-agreements/containers';
import { EditConditionDialog } from '../../ConditionActionsBase';

interface Props {
  open: boolean;
  primaryText: string;
  assortmentId: number;
  supplierItemId: number;
  onClose: () => void;
}

function EditItemAgreementConditionDialog({
  primaryText,
  assortmentId,
  supplierItemId,
  onClose,
}: Props) {
  const t = useAppTFunction();
  const { createOrUpdateCondition, isLoadingPostChanges } = useConditionActions();

  const [selectedAgreement, selectAgreement] = useState<ItemAgreementPrices | undefined>(undefined);

  const submitAgreements = useCallback(() => {
    createOrUpdateCondition({
      content: {
        purchase: {
          agreementId: selectedAgreement!.agreementId,
          priceType: selectedAgreement?.priceType,
          packageType: selectedAgreement?.packageType,
        },
      },
      bindingValue: toConditionBinding({ supplierItemId }),
      validFrom: new Date(),
    });
    onClose();
  }, [createOrUpdateCondition, selectedAgreement, supplierItemId, onClose]);

  return (
    <EditConditionDialog
      open
      title={t('purchaseAgreements.agreement.actions.editConditionFor', {
        name: primaryText,
      })}
      dialogContent={
        <SelectItemAgreements
          assortmentId={assortmentId}
          supplierItemId={supplierItemId}
          selectAgreement={selectAgreement}
        />
      }
      isDisabled={!!selectedAgreement?.isActive || !selectedAgreement}
      isLoading={isLoadingPostChanges}
      onClose={onClose}
      onSubmit={submitAgreements}
    />
  );
}

export default withDialogSuspenseErrorBoundary(EditItemAgreementConditionDialog);
